import script from "./pemakaian-nol-page.vue?vue&type=script&setup=true&lang=js"
export * from "./pemakaian-nol-page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__